module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.d94f87d5.jpg";